import { SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Stack from "@mui/material/Stack";
import { Icons } from "@repo/ui";
import { type FC, type PropsWithChildren, type ReactNode, useState } from "react";
import TriggerButton from "../Link/TriggerButton";

export type CollapsibleProps = PropsWithChildren<{
	headline: ReactNode;
}>

const Collapsible: FC<CollapsibleProps> = ({
	headline,
	children,
	...rest
}) => {
	const [checked, setChecked] = useState(false);
	;
	return (
		<Box
			{...rest}
			sx={{
				paddingTop: checked ? "0" : "1px",
				borderTopWidth: checked ? "2px" : "1px",
				borderTopStyle: "solid",
				borderTopColor: checked ? "primary.main" : "grey.light",
			}}
		>
			<TriggerButton
				variant="collapsible"
				size="small"
				endIcon={
					<Icons.CaretDown
						sx={{
							width: "14px",
							transform: checked ? "rotate(180deg)" : "rotate(0deg)",
							transformOrigin: "center center",
							transition: "transform 0.2s",
						}}
					/>
				}
				onClick={() => {
					setChecked((prev) => !prev);
				}}
			>
				<span>{headline}</span>
			</TriggerButton>
			<Collapse in={checked} orientation="vertical">
				<Box sx={{ pt: 3, pb: 5 }}>{children}</Box>
			</Collapse>
		</Box>
	);
};



export type CookieCollapsibleProps = PropsWithChildren<{
	headline: string;
	selector?: ReactNode;
	sx?: SxProps
}>

export const CookieCollapsible: FC<CookieCollapsibleProps> = ({
	headline,
	children,
	selector,
	sx,
}) => {
	const [checked, setChecked] = useState(false);
	return (
		<Box
			sx={{
				...sx,
				border: "1px solid",
				borderColor: "grey.light",
				borderRadius: "4px",
			}}
		>
			<TriggerButton
				variant="cookie-collapsible"
				startIcon={
					<Icons.CaretDown
						sx={{
							width: "14px",
							transform: checked ? "rotate(180deg)" : "rotate(0deg)",
							transformOrigin: "center center",
							transition: "transform 0.2s",
						}}
					/>
				}
				size="small"
				onClick={() => { setChecked((prev) => !prev); }}
			>
				{headline}
				{selector && (
					<Box
						sx={{ ml: "auto" }}
						onClick={(event) => {
							event.stopPropagation();
						}}
					>
						{selector}
					</Box>
				)}
			</TriggerButton>
			<Collapse in={checked}>
				<Stack sx={{ pb: 4, px: 4 }} spacing={4}>
					{children}
				</Stack>
			</Collapse>
		</Box>
	);
};

export default Collapsible;
